App.controller('UserSearchCtrl', UserSearchCtrl);

UserSearchCtrl.$inject = [
    'DialogService',
    'userFactory',
    'users'
];

function UserSearchCtrl(DialogService, userFactory, users) {
    var vm = this;

    vm.search = '';
    vm.users = users;

    vm.destroy = destroy;

    function destroy(index) {
        DialogService.confirm('delete this user', null, function(confirmed) {
            if (confirmed) {

                userFactory.destroy(vm.users[index].id).then(function() {
                    DialogService.success('User has been successfully deleted');

                    vm.users.splice(index, 1);
                });
            }
        });
    }
}